module.exports = __webpack_public_path__ + "img/etc-etc-fundanow-money.754d9aab.svg";